import Axios from 'axios'
import config from './config'
import { callAuthenticatedApi } from './authenticated-api'

const apiUrls = {
  remote: config.clientsRemoteApiUrl,
  local: config.clientsLocalApiUrl
}

const apiError = (err, fallbackMessage) => err.response?.data ?? { ok: false, error: { message: fallbackMessage } }

const getClientDetails = async ({ apiSource, apiKey, includeChildClientId = false }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/getClientDetails`,
      method: "get"
    }

    let result = await callApi({ apiKey, includeChildClientId, options })

    return result
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error getting client details")
  }
}

const getUsers = async ({ apiSource, apiKey }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/getUsers`,
      method: "get"
    }

    let result = await callApi({ apiKey, options })

    return result
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error getting user list")
  }
}

const saveUser = async ({ apiSource, apiKey, user }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/saveUser/${user.user_id}`,
      method: "patch",
      data: {user}
    }

    let result = await callApi({ apiKey, options })

    return result
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error saving user")
  }
}

const saveClientDetails = async ({ apiSource, apiKey, client }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/saveClientDetails`,
      method: "patch",
      data: client
    }

    let result = await callApi({ apiKey, includeChildClientId: false, options })

    return result
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error saving client details")
  }
}

const saveClientMainContact = async ({ apiSource, apiKey, client, includeChildClientId = false }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/saveClientMainContact`,
      method: "patch",
      data: client
    }

    let result = await callApi({ apiKey, includeChildClientId, options })

    return result
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error saving client contact")
  }
}

const getClientStatistics = async ({ apiSource, apiKey, period_days, template_id }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/getClientStatistics`,
      method: "get",
      params: {
        period_days,
        ...(template_id ? { template_id } : {})
      }
    }

    return await callApi({ apiKey, options })
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error getting statistics")
  }
}

const addApiKey = async ({ apiSource, apiKey, keyName }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/addApiKey`,
      method: "put",
      data: { key_name: keyName }
    }

    let result = await callApi({ apiKey, options, includeChildClientId:false })

    return result
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error adding client key")
  }
}


const deleteApiKey = async ({ apiSource, apiKey, keyId }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/deleteApiKey/${keyId}`,
      method: "delete"
    }

    let result = await callApi({ apiKey, options })

    return result
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error deleting client key")
  }
}

const setApiKeyStatus = async ({ apiSource, apiKey, keyId, status }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/setApiKeyStatus/${keyId}/${status}`,
      method: "patch",
      data: {}
    }

    let result = await callApi({ apiKey, options })

    return result
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error setting key status")
  }
}


const addUser = async ({ apiSource, apiKey, user }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/addUser`,
      method: "put",
      data: user
    }

    let result = await callApi({ apiKey, options })

    return result
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error adding user")
  }
}


const deleteUser = async ({ apiSource, apiKey, userId }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/deleteUser/${userId}`,
      method: "delete"
    }

    let result = await callApi({ apiKey, options })

    return result
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error deleting user")
  }
}




const getInvoices = async ({ apiSource, apiKey }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/getInvoices`,
      method: "get"
    }

    let result = await callApi({ apiKey, options })

    return result
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error getting invoices")
  }
}

const toggleApiKeyClientFunctionAccess = async ({ apiSource, apiKey, keyId }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/toggleApiKeyClientFunctionAccess/${keyId}`,
      method: "patch"
    }

    let result = await callApi({ apiKey, options })

    return result
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error setting API key access permissions")
  }
}

const getCreditsBalance = async ({ apiSource, apiKey, includeChildClientId = false }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/getCreditsBalance`,
      method: "get"
    }

    let result = await callApi({ apiKey, includeChildClientId, options })

    return result
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error getting credits balance")
  }
}

const getlastBundlePurchase = async ({ apiSource, apiKey }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/getlastBundlePurchase`,
      method: "get"
    }

    let result = await callApi({ apiKey, options })

    return result
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error getting last credit bundle purcahse details")
  }
}

const getCreditUsage = async ({ apiSource, apiKey, period_days, offset = 0, limit = 250 }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/getCreditUsage`,
      method: "get",
      params: {
        period_days,
        offset,
        limit
      }
    }

    let result = await callApi({ apiKey, includeChildClientId: false, options })

    return result
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error getting credits usage")
  }
}


const purchaseCreditBundle = async ({ apiSource, apiKey, purchase_bundle_name, auto_topup_bundle, threshold }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/purchaseCreditBundle`,
      method: "post",
      data : {
        purchase_bundle_name,
        auto_topup_bundle,
        threshold
      }
    }

    let result = await callApi({ apiKey, options })

    return result
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error purchasing credits bundle")
  }
}

const getFreeCreditsDetails = async ({ apiSource, apiKey }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/getFreeCreditsDetails`,
      method: "get"
    }

    let result = await callApi({ apiKey, options, includeChildClientId:false })

    return result
  }
  catch (err) {
    console.error(err)
    return apiError(err, "Error getting free credits details")
  }
}

const callApi = async ({ apiKey, includeChildClientId = true, options }) => {
  try {
    return await callAuthenticatedApi({
      apiSource: getApiSourceFromUrl(options.url),
      apiKey,
      includeChildClientId,
      options
    })
  }
  catch (err) {
    throw err
  }
}

const getApiSourceFromUrl = url => {
  return url?.startsWith(apiUrls.local) ? 'local' : 'remote'
}

export {
  //client
  addApiKey,
  addUser,
  deleteApiKey,
  deleteUser,
  getClientDetails,
  getClientStatistics,
  getUsers,
  saveClientMainContact,
  saveClientDetails,
  setApiKeyStatus,
  saveUser,
  toggleApiKeyClientFunctionAccess,
  // billing
  getInvoices,
  getCreditsBalance,
  getCreditUsage,
  getlastBundlePurchase,
  purchaseCreditBundle,
  getFreeCreditsDetails,
}
